/* eslint-disable no-plusplus */
/* eslint-disable max-len */
import {
  format, parseISO, formatISO,
} from 'date-fns';
import NProgress from 'nprogress/nprogress';

import * as types from '@/store/types';
import {
  removeNamespaces, showMessage,
} from '@/helpers/utils';
import { api } from '@/helpers/api';
import analysisApi from '@/helpers/analysis-api';

import { SIGNERS } from '@/helpers/constsIndemnity';
import {
  showPdf, getBase64Pdf, preformatTableRows, getBlobPdf,
} from '@/components/Indemnity/indemnityUtils';

const localTypes = removeNamespaces(types);

export default {
  async [localTypes.INDEMNITY_GET_LETTER_BY_ID]({ commit }, { id, isReferral }) {
    NProgress.start();

    try {
      const params = new URLSearchParams();

      if (id) params.append('id', id);

      let letter = null;

      if (isReferral) {
        const { data: { data } } = await api.get('v3/referral/get', { params });
        letter = data;
      } else {
        const { data } = await api.get('v2/Indemnity/get', { params });
        letter = data;
      }

      const { tableColumns } = letter;
      const tableRows = letter.tableRows.map((row) => {
        if (typeof row === 'object') {
          const newRow = {};
          Object.keys(row).forEach((key) => {
            const rowFieldValue = row[key];
            const rowFieldKey = key[0].toLowerCase() + key.substring(1);
            newRow[rowFieldKey] = {
              isVisible: rowFieldValue.IsVisible ?? rowFieldValue.isVisible,
              value: rowFieldValue.Value ?? rowFieldValue.value,
            };
          });

          // const newRow = { ...row };
          newRow.number.isVisible = tableColumns['№'];
          newRow.code.isVisible = tableColumns['Код услуги'];
          newRow.name.isVisible = tableColumns['Наименование услуги'];
          newRow.count.isVisible = tableColumns['Количество услуг'];
          newRow.price.isVisible = tableColumns['Стоимость за единицу'];
          newRow.sum.isVisible = tableColumns['Итоговая стоимость'];
          return newRow;
        }
        return row;
      });

      const letterData = {
        ...letter,
        tableRows,
      };

      commit(localTypes.INDEMNITY_LETTER_SET, letterData);

      return letterData;
    } catch (e) {
      showMessage({ type: 'error', message: 'Не удалось получить письмо' });
      throw e;
    } finally {
      NProgress.done();
    }
  },
  async [localTypes.INDEMNITY_TEMPLATES_FETCH]({ commit }, query) {
    NProgress.start();
    try {
      const { data } = await api.get(`Indemnity/Templates/${query}`);

      const templates = data.map((template) => {
        const rows = template.rows.map((row) => {
          if (typeof row === 'object') {
            const newRow = {};
            Object.keys(row).forEach((key) => {
              const rowFieldValue = row[key];
              const rowFieldKey = key[0].toLowerCase() + key.substring(1);
              newRow[rowFieldKey] = {
                isVisible: rowFieldValue.IsVisible ?? rowFieldValue.isVisible,
                value: rowFieldValue.Value ?? rowFieldValue.value,
              };
            });

            return newRow;
          }

          return row;
        });
        return { ...template, rows };
      });

      commit(localTypes.INDEMNITY_TEMPLATE_SET, templates);
      return templates;
    } catch (e) {
      console.warn(e);
    } finally {
      NProgress.done();
    }
  },
  async [localTypes.INDEMNITY_TEMPLATE_DELETE]({ commit }, id) {
    NProgress.start();
    try {
      await api.delete(`v2/indemnity/template/${id}`);
      showMessage({
        type: 'success',
        title: 'Успешно',
        message: 'Шаблон ГП успешно удален!',
      });
      commit(localTypes.INDEMNITY_TEMPLATE_REMOVE_BY_ID, id);
    } catch (e) {
      console.warn(e);

      showMessage({
        type: 'error',
        title: 'Ошибка',
        message: 'Не удалось удалить шаблон ГП',
      });

      throw new Error(e);
    } finally {
      NProgress.done();
    }
  },
  async [localTypes.INDEMNITY_CREATE_EDIT_LETTER]({ commit }, { id, isReferral }) {
    NProgress.start();

    try {
      const params = new URLSearchParams();

      if (id) params.append('id', id);

      let letter = null;
      if (isReferral) {
        const { data: { data } } = await api.get('v3/referral/edit', { params });
        letter = data;
      } else {
        const { data } = await api.get('Indemnity/editLetter', { params });
        letter = data;
      }

      const { tableColumns } = letter;
      const tableRows = letter.tableRows.map((row) => {
        if (typeof row === 'object') {
          const newRow = {};
          Object.keys(row).forEach((key) => {
            const rowFieldValue = row[key];
            const rowFieldKey = key[0].toLowerCase() + key.substring(1);
            newRow[rowFieldKey] = {
              isVisible: rowFieldValue.IsVisible ?? rowFieldValue.isVisible,
              value: rowFieldValue.Value ?? rowFieldValue.value,
            };
          });

          // const newRow = { ...row };
          newRow.number.isVisible = tableColumns['№'];
          newRow.code.isVisible = tableColumns['Код услуги'];
          newRow.name.isVisible = tableColumns['Наименование услуги'];
          newRow.count.isVisible = tableColumns['Количество услуг'];
          newRow.price.isVisible = tableColumns['Стоимость за единицу'];
          newRow.sum.isVisible = tableColumns['Итоговая стоимость'];
          return newRow;
        }
        return row;
      });

      const letterData = {
        ...letter,
        tableRows,
      };

      commit(localTypes.INDEMNITY_LETTER_SET, letterData);

      return letterData;
    } catch (e) {
      showMessage({ type: 'error', message: 'Не удалось получить письмо' });
      throw e;
    } finally {
      NProgress.done();
    }
  },
  async [localTypes.INDEMNITY_LETTER_NEW_GET]({ commit }, {
    personId,
    policyId,
    subProgramId,
    clinicId,
    isReferral,
  }) {
    NProgress.start();

    try {
      let newLetter = null;

      if (isReferral) {
        const body = {};
        if (policyId) body.policyId = policyId;
        if (personId) body.personId = personId;
        if (subProgramId) body.subProgramId = subProgramId;
        if (clinicId) body.clinicId = clinicId;

        const { data: { data } } = await api.post('v3/referral/new', body);
        newLetter = data;
      } else {
        const params = new URLSearchParams();
        if (policyId) params.append('policyId', policyId);
        if (personId) params.append('personId', personId);
        if (subProgramId) params.append('subProgramId', subProgramId);
        if (clinicId) params.append('clinicId', clinicId);

        const { data } = await api.get('Indemnity/Letters/new', { params });
        newLetter = data;
      }

      commit(localTypes.INDEMNITY_LETTER_SET,
        {
          ...newLetter,
          tableColumns: {
            '№': true,
            'Код услуги': true,
            'Наименование услуги': true,
            'Количество услуг': true,
            'Стоимость за единицу': true,
            'Итоговая стоимость': true,
          },
          creationDate: formatISO(new Date()),
        });
    } catch (e) {
      showMessage({ type: 'error', message: 'Не удалось создать новое письмо' });
      throw e;
    } finally {
      NProgress.done();
    }
  },
  async [localTypes.INDEMNITY_LETTER_SAVE]({
    commit,
    dispatch,
    state: {
      personId,
    },
    rootState: {
      ClinicDocuments: { clinicId },
    },
  }, letter) {
    NProgress.start();
    try {
      commit(localTypes.INDEMNITY_IS_LETTER_SAVING_SET, true);

      let newLetter = null;

      if (letter.isReferral) {
        const { data: { data } } = await api.post('v3/referral/save', letter);
        newLetter = data;
      } else {
        const { data } = await api.post('Indemnity/SaveLetter', letter);
        newLetter = data;
      }

      showMessage({
        type: 'success',
        title: 'Успешно',
        message: 'Письмо успешно сохранено',
      });

      if (clinicId) {
        dispatch(localTypes.INDEMNITY_LETTERS_GET_BY_CLINIC, clinicId);
      } else {
        dispatch(localTypes.INDEMNITY_LIST_NAMES_FETCH, {
          personId: newLetter.personId || personId,
          policyId: newLetter.policy.id,
        });
      }

      return newLetter;
    } catch (e) {
      console.log(e);
      showMessage({ type: 'error', message: 'Не удалось сохранить письмо' });
      throw (e);
    } finally {
      commit(localTypes.INDEMNITY_IS_LETTER_SAVING_SET, false);
      NProgress.done();
    }
  },
  async [localTypes.INDEMNITY_LETTER_CREATE_DUBLES](_, params) {
    NProgress.start();
    try {
      const { data } = await api.post('v2/indemnity/create-doubles', params);

      return data;
    } catch (e) {
      console.log(e);
      showMessage({ type: 'error', message: 'Не удалось создать дубли письма' });
      throw (e);
    } finally {
      NProgress.done();
    }
  },
  async [localTypes.INDEMNITY_LETTERS_SAVE](_, params) {
    NProgress.start();
    try {
      const { data } = await api.post('v2/indemnity/send-letters', params);

      return data;
    } catch (e) {
      console.log(e);
      showMessage({ type: 'error', message: 'Не удалось отправить письма' });
      throw (e);
    } finally {
      NProgress.done();
    }
  },
  async [localTypes.GET_LETTER_COLUMN_WIDTH](_, { letter }) {
    const splicedKeys = Object.keys(letter.tableColumns).filter((col) => col !== 'Наименование услуги');
    const defaultWidths = {
      '№': 20,
      'Код услуги': 50,
      'Наименование услуги': 0,
      'Количество услуг': 65,
      'Стоимость за единицу': 60,
      'Итоговая стоимость': 60,
    };
    defaultWidths['Наименование услуги'] = splicedKeys.reduce((acc, key) => (letter.tableColumns[key] ? acc : acc + defaultWidths[key]), 200);

    const visibleKeys = Object.keys(letter.tableColumns).filter((key) => letter.tableColumns[key]);
    return visibleKeys.map((key) => defaultWidths[key]);
  },
  async [localTypes.INDEMNITY_LETTER_FORM]({ dispatch }, { letter: letterData }) {
    NProgress.start();

    try {
      const letter = JSON.parse(JSON.stringify({
        ...letterData,
      }));

      if ([2, 3].includes(letter.priceType)) {
        letter.tableColumns = {
          '№': true,
          'Код услуги': true,
          'Наименование услуги': true,
          'Количество услуг': true,
          'Стоимость за единицу': !letter.isWithoutPrice,
          'Итоговая стоимость': !letter.isWithoutPrice,
        };

        let tableRowsPrices = [];

        if (letter.priceType === 2) {
          letter.tableRowsPrice.forEach((price) => {
            const tablePrice = tableRowsPrices.find((p) => p.id === price.id);
            if (tablePrice) {
              tablePrice.count += 1;
              return;
            }

            tableRowsPrices.push({
              ...price,
              count: 1,
            });
          });

          letter.sumString = letter.tableRows.reduce((acc, item) => acc + item.price.value * item.count.value, 0);
        }

        if (letter.priceType === 3) {
          tableRowsPrices = letter.tableRowsPrice.reduce((result, item) => {
            const itemInResult = result.find((i) => i.id === item.id);

            if (itemInResult) {
              itemInResult.count += 1;
            } else {
              result.push({ ...item, count: item.count || 1 });
            }
            return result;
          }, []);
        }

        letter.tableRows = tableRowsPrices.map((price, i) => ({
          number: {
            isVisible: true,
            value: i + 1,
          },
          name: {
            isVisible: true,
            value: price.name || '',
          },
          code: {
            isVisible: true,
            value: price.code || '',
          },
          count: {
            isVisible: true,
            value: price.count || 1,
          },
          price: {
            // isVisible: true,
            isVisible: !letter.isWithoutPrice,
            value: price.cost || 0,
          },
          sum: {
            // isVisible: true,
            isVisible: !letter.isWithoutPrice,
            value: (price.cost || 0) * (price.count || 1),
          },
        }));

        if (letter.serviceString) {
          letter.tableRows.push({
            number: {
              isVisible: true,
              value: null,
            },
            name: {
              isVisible: true,
              value: letter.serviceString,
            },
            code: {
              isVisible: true,
              value: null,
            },
            count: {
              isVisible: true,
              value: null,
            },
            price: {
              // isVisible: true,
              isVisible: !letter.isWithoutPrice,
              value: null,
            },
            sum: {
              // isVisible: true,
              isVisible: !letter.isWithoutPrice,
              value: null,
            },
          });
        }
      } else {
        const { tableColumns, tableRows } = preformatTableRows(letter.tableRows);
        letter.tableColumns = tableColumns;
        letter.tableRows = tableRows;
      }

      const uslugi = letter.tableRows.filter((row) => typeof row === 'object');
      const finalPrice = uslugi.reduce((acc, usluga) => acc + usluga.price.value * usluga.count.value, 0);
      const finalCount = uslugi.reduce((acc, usluga) => acc + usluga.count.value, 0);
      const colSpan = Object.values(letter.tableColumns).reduce((acc, item) => (item ? acc + 1 : acc), 0);
      const widths = await dispatch(localTypes.GET_LETTER_COLUMN_WIDTH, { letter });
      const { middleName, firstName, lastName } = letter.patient;
      const rows = letter.tableRows.map((row) => {
        if (typeof row !== 'object') {
          return [{
            text: row,
            style: 'tableHeader',
            alignment: 'center',
            colSpan,
          }];
        }

        return ['number', 'code', 'name', 'count', 'price', 'sum']
          .filter((key) => row[key].isVisible)
          .map((key) => row[key].value);
      });

      const belowTable = letter.isWithoutPrice || (letter.priceType === 0 && (letter.sumString === '' || letter.sumString == null))
        ? ''
        : `в размере ${Math.floor(finalPrice)} ${!letter.sumString || +letter.sumString === +finalPrice ? '' : `(${letter.sumString})`} рублей ${Math.round(finalPrice - Math.floor(finalPrice))} копеек ${letter.paymentConditionString ? `${letter.paymentConditionString.trim()}.` : ''}`;

      const docdef = {
        headerTitle: letter.isReferral ? 'Направление' : 'Гарантийное письмо',
        topRight: `${letter.recipientPosition}
                  ${letter.clinic?.legalPerson?.name || letter.clinic?.legalPersonName || ''}
                  ${letter.recipientName}
                  ${letter.clinic.inn && letter.clinic.kpp ? `ИНН / КПП\n ${letter.clinic.inn} / ${letter.clinic.kpp}` : ''}
                  от ООО "Диджитал Медикэл
                  Оперейшнс" (ООО "ДМО")
                  ИНН / КПП
                  7725319742 / 773101001
                  `,
        rows,
        aboveTable: letter.isReferral ? `
          Общество с ограниченной ответственностью «Диджитал Медикэл Оперейшнс», (сокращенное наименование ООО «ДМО») направило к вам пациента ${lastName || ''} ${firstName || ''} ${middleName || ''} ${letter.patient.birthDate ? `, ${format(parseISO(letter.patient.birthDate), 'dd.MM.yyyy')}` : ''} на оказание медицинской помощи в "${letter.clinic.title}", ${letter.clinic.addressString}, в соответствии с агентским договором ${letter.clinic?.contractNumber || ''}.

          [√]  Данные пациента переданы сотруднику контакт-центра
          [x]  Пациент записан через интеграцию с МИС

        ` : `Общество с ограниченной ответственностью «Диджитал Медикэл Оперейшнс», (сокращенное наименование ООО «ДМО») гарантирует произвести оплату в "${letter.clinic.title}", ${letter.clinic.addressString} за пациента ${lastName || ''} ${firstName || ''} ${middleName || ''}${letter.patient.birthDate ? `, ${format(parseISO(letter.patient.birthDate), 'dd.MM.yyyy')}` : ''}${letter.policy.policyId ? `, полис ${letter.policy.policyId}` : ''}, за следующие услуги:`,
        programName: letter.isReferral ? 'от сервиса «Доверенный врач»' : (letter.indemnityLetterHeader || ''),
        widths,
        // belowTable: letter.sumString
        //   ? `в размере ${Math.floor(finalPrice)} ${+letter.sumString === +finalPrice ? '' : `(${letter.sumString})`} рублей ${Math.round(finalPrice - Math.floor(finalPrice))} копеек ${letter.paymentConditionString ? `${letter.paymentConditionString.trim()}.` : ''}`
        //   : '',
        belowTable,
        period: `Данное ${letter.isReferral ? 'направление' : 'гарантийное письмо'} действительно ${letter.validityString ? letter.validityString.trim() : `до ${format(parseISO(letter.validityDate), 'dd.MM.yyyy')}`}.`,
        doctisLogo: 'data:image/png;base64,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',
        comment: letter.additionalConditionString || '',
        signerPosition: letter.signerPosition,
        signerName: letter.signerName,
        signerAutograf: SIGNERS.find((signer) => signer.name === letter.signerName).autografImage,
        executorName: letter.executorName,
        executorPosition: letter.executorPosition,
        numberString: `Исх. номер ${letter.documentNumber} от ${format(parseISO(letter.creationDate), 'dd.MM.yyyy')}`,
        footer: letter.footer,
      };
      docdef.rows.unshift(Object.keys(letter.tableColumns).filter((key) => letter.tableColumns[key]));
      if (letter.finalRow) {
        const colSpanName = Object.keys(letter.tableColumns).slice(0, 3).reduce((acc, key) => (letter.tableColumns[key] ? acc + 1 : acc), 0);

        const dfRow = [
          {
            text: 'Итого:',
            colSpan: colSpanName,
            style: 'tableHeader',
            alignment: 'right',
          },
        ];

        for (let i = 0; i < colSpanName - 1; i++) {
          dfRow.push('');
        }

        if (letter.tableColumns['Количество услуг']) {
          dfRow.push({
            text: finalCount,
            style: 'tableHeader',
            alignment: 'center',
          });
        }

        if (letter.tableColumns['Стоимость за единицу']) {
          dfRow.push({
            text: '',
            style: 'tableHeader',
            alignment: 'center',
          });
        }

        if (letter.tableColumns['Итоговая стоимость']) {
          dfRow.push({
            text: finalPrice,
            style: 'tableHeader',
            alignment: 'center',
          });
        }

        docdef.rows.push(dfRow);
      }

      return docdef;
    } catch (e) {
      showMessage({ type: 'error', message: 'Не удалось сформировать письмо' });
      console.log(e);
      throw (e);
    } finally {
      NProgress.done();
    }
  },
  async [localTypes.INDEMNITY_ANNULMENT_LETTER_FORM](_, { letter, annulmentReason }) {
    NProgress.start();
    try {
      const { middleName, firstName, lastName } = letter.patient;

      const docdef = {
        hideTable: true,
        headerTitle: `Аннулирование ${letter.isReferral ? 'направления' : 'гарантийного письма'}`,
        topRight: `${letter.recipientPosition}
                  ${letter.clinic?.legalPerson?.name || letter.clinic?.legalPersonName || ''}
                  ${letter.recipientName}
                  ${letter.clinic.inn && letter.clinic.kpp ? `ИНН / КПП\n ${letter.clinic.inn} / ${letter.clinic.kpp}` : ''}
                  от ООО "Диджитал Медикэл
                  Оперейшнс" (ООО "ДМО")
                  ИНН / КПП
                  7725319742 / 773101001`,
        aboveTable: `Просьба аннулировать ${letter.isReferral ? 'направление' : 'гарантийное письмо'} исх. номер ${letter.documentNumber} от ${format(parseISO(letter.creationDate), 'dd.MM.yyyy')} на пациента ${lastName || ''} ${firstName || ''} ${middleName || ''},
        по причине:
        ${annulmentReason || letter.reasonAnnulment || 'не указано'}`,
        programName: '',
        belowTable: '',
        period: '',
        comment: '',
        signerPosition: letter.signerPosition,
        signerName: letter.signerName,
        executorName: letter.executorName,
        executorPosition: letter.executorPosition,
        doctisLogo: 'data:image/png;base64,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',
        signerAutograf: SIGNERS.find((signer) => signer.name === letter.signerName).autografImage,
        numberString: `Исх. номер ${letter.documentNumber}-A от ${format(parseISO(letter.modifyDate), 'dd.MM.yyyy')}`,
        footer: letter.footer,
      };

      return docdef;
    } catch (e) {
      showMessage({ type: 'error', message: 'Не удалось сформировать письмо' });
      console.log(e);
      throw (e);
    } finally {
      NProgress.done();
    }
  },
  async [localTypes.INDEMNITY_LETTER_PRINT]({ dispatch }, letter) {
    NProgress.start();

    try {
      // const docdef = await dispatch(localTypes.INDEMNITY_LETTER_FORM);
      const docdef = await dispatch(letter.isAnnulment ? localTypes.INDEMNITY_ANNULMENT_LETTER_FORM : localTypes.INDEMNITY_LETTER_FORM, { letter });
      showPdf(docdef);

      return docdef;
    } finally {
      NProgress.done();
    }
  },
  async [localTypes.INDEMNITY_LETTER_MAKE_PDF]({ dispatch }, letter) {
    NProgress.start();

    try {
      // const docdef = await dispatch(localTypes.INDEMNITY_LETTER_FORM);
      const docdef = await dispatch(letter.isAnnulment ? localTypes.INDEMNITY_ANNULMENT_LETTER_FORM : localTypes.INDEMNITY_LETTER_FORM, { letter });
      const pdf = getBlobPdf(docdef);

      return pdf;
    } finally {
      NProgress.done();
    }
  },
  async [localTypes.INDEMNITY_LETTER_SEND]({
    state: {
      personId,
    },
    dispatch,
    commit,
    rootState: {
      // Patients: { policy },
      ClinicDocuments: { clinicId },
    },
  }, {
    letter,
    annulment,
  } = { annulment: false }) {
    NProgress.start();

    try {
      commit(localTypes.INDEMNITY_IS_LETTER_SENDING_SET, true);
      const docdef = await dispatch(annulment ? localTypes.INDEMNITY_ANNULMENT_LETTER_FORM : localTypes.INDEMNITY_LETTER_FORM, { letter });
      const base64pdf = await getBase64Pdf(docdef);

      const { data } = await api.post(letter.isReferral ? 'v3/referral/send' : 'Indemnity/SendLetter', {
        letter,
        base64pdf: `data:application/pdf;base64,${base64pdf}`,
      });

      if (data === false) throw new Error(`Не удалось отправить ${letter.isReferral ? 'направление' : 'письмо'}`);

      showMessage({
        type: 'success',
        title: 'Успешно',
        message: `${letter.isReferral ? 'Направление' : 'Письмо'} успешно отправлено`,
      });

      if (clinicId) {
        await dispatch(localTypes.INDEMNITY_LETTERS_GET_BY_CLINIC, clinicId);
      } else {
        await dispatch(localTypes.INDEMNITY_LIST_NAMES_FETCH, {
          personId: letter.personId || personId,
          policyId: letter.policy.id,
        });
      }
    } catch (e) {
      showMessage({ type: 'error', message: `Не удалось отправить ${letter.isReferral ? 'направление' : 'письмо'}` });
      throw new Error(`Не удалось отправить ${letter.isReferral ? 'направление' : 'письмо'}`);
    } finally {
      commit(localTypes.INDEMNITY_IS_LETTER_SENDING_SET, false);
      NProgress.done();
    }
  },
  async [localTypes.INDEMNITY_LIST_NAMES_FETCH]({ commit, state }, { personId, policyId }) {
    NProgress.start();

    try {
      commit(localTypes.INDEMNITY_LETTERS_LOADING_SET, true);
      const params = new URLSearchParams();
      if (personId) params.append('personId', personId);
      if (policyId && !state.historyWithoutPolicy) params.append('policyId', policyId);

      const { data } = await api.get('v2/indemnity/getListNames', { params });
      commit(localTypes.INDEMNITY_LETTERS_SET, data);

      if (policyId) {
        const { data: analysisIds } = await api.get(`v2/policy?policyId=${policyId}`);
        const analysisPromiseData = await Promise.allSettled(analysisIds.map((id) => analysisApi.get(`/insurance_order/${id}/`)));
        const analysisData = analysisPromiseData.map((a) => a.value.data);
        commit(localTypes.INDEMNITY_ANALYSIS_LETTERS_SET, analysisData);
      }
    } catch (e) {
      showMessage({ type: 'error', message: 'Не удалось получить гарантийные письма' });
    } finally {
      commit(localTypes.INDEMNITY_LETTERS_LOADING_SET, false);
      NProgress.done();
    }
  },
  async [localTypes.INDEMNITY_LIST_FETCH]({ commit, state }, { personId, policyId, isReferral }) {
    NProgress.start();

    try {
      commit(localTypes.INDEMNITY_LETTERS_LOADING_SET, true);
      const params = new URLSearchParams();
      if (personId) params.append('personId', personId);
      if (policyId && !state.historyWithoutPolicy) params.append('policyId', policyId);

      let letters = null;
      if (isReferral) {
        const { data: { data } } = await api.get('v3/referral/list', { params });
        letters = data;
      } else {
        const { data } = await api.get(isReferral ? 'v3/referral/list' : 'v2/indemnity/list', { params });
        letters = data;
      }

      commit(localTypes.INDEMNITY_LETTERS_SET, letters);
    } catch (e) {
      showMessage({ type: 'error', message: 'Не удалось получить гарантийные письма' });
    } finally {
      commit(localTypes.INDEMNITY_LETTERS_LOADING_SET, false);
      NProgress.done();
    }
  },
  async [localTypes.INDEMNITY_LETTERS_GET_BY_CLINIC]({ commit }, clinicId) {
    NProgress.start();
    try {
      commit(localTypes.INDEMNITY_LETTERS_LOADING_SET, true);
      // const { data } = await api.get(`Indemnity/Letters/${policyId}`);
      // const { data } = await api.get(`Indemnity/LettersForClinic/${clinicId}`);
      const params = new URLSearchParams();
      if (clinicId) params.append('clinicId', clinicId);

      const { data } = await api.get('v2/indemnity/getListNamesByClinic', { params });
      commit(localTypes.INDEMNITY_LETTERS_SET, data);
    } catch (e) {
      showMessage({ type: 'error', message: 'Не удалось получить гарантийные письма' });
    } finally {
      commit(localTypes.INDEMNITY_LETTERS_LOADING_SET, false);
      NProgress.done();
    }
  },

  [localTypes.INDEMNITY_LETTER_NUMBERS_UPDATE]({ state: { letter }, commit }) {
    let counter = 0;

    const rows = letter.tableRows.map((row) => {
      if (typeof row === 'string') return row;

      counter += 1;
      return { ...row, number: { isVisible: row.number.isVisible, value: counter } };
    });

    const { tableColumns, tableRows } = preformatTableRows(rows);

    commit(localTypes.INDEMNITY_LETTER_SET, {
      ...letter,
      tableRows,
      tableColumns,
    });
  },
  async [localTypes.INDEMNITY_EDIT_TEMPLATE_UPDATE]({ commit, state: { editTemplate } }) {
    NProgress.start();
    try {
      commit(localTypes.INDEMNITY_IS_EDIT_TEMPLATE_SAVING_SET, true);

      await api.put('v2/indemnity/template', editTemplate);

      showMessage({
        type: 'success',
        title: 'Успешно',
        message: 'Шаблон успешно сохранен',
      });
    } catch (e) {
      showMessage({ type: 'error', message: 'Не удалось сохранить шаблон' });
      throw (e);
    } finally {
      commit(localTypes.INDEMNITY_IS_EDIT_TEMPLATE_SAVING_SET, false);

      NProgress.done();
    }
  },
  async [localTypes.INDEMNITY_EDIT_TEMPLATE_SAVE]({ commit, state: { editTemplate } }) {
    NProgress.start();
    try {
      commit(localTypes.INDEMNITY_IS_EDIT_TEMPLATE_SAVING_SET, true);

      await api.post('v2/indemnity/template/save', editTemplate);

      showMessage({
        type: 'success',
        title: 'Успешно',
        message: 'Новый шаблон успешно сохранен',
      });
    } catch (e) {
      showMessage({ type: 'error', message: 'Не удалось сохранить новый шаблон' });
      throw (e);
    } finally {
      commit(localTypes.INDEMNITY_IS_EDIT_TEMPLATE_SAVING_SET, false);

      NProgress.done();
    }
  },
  [localTypes.INDEMNITY_EDIT_TEMPLATE_NUMBERS_UPDATE]({ state: { editTemplate }, commit }) {
    let counter = 0;

    const rows = editTemplate.rows.map((row) => {
      if (typeof row === 'string') return row;

      counter += 1;
      return { ...row, number: { isVisible: row.number.isVisible, value: counter } };
    });

    commit(localTypes.INDEMNITY_EDIT_TEMPLATE_SET, {
      ...editTemplate,
      rows,
    });
  },
  async [localTypes.INDEMNITY_LETTER_DELETE](ctx, { id, isReferral }) {
    NProgress.start();

    try {
      if (isReferral) {
        await api.delete(`v3/referral?id=${id}`);
      } else {
        await api.delete(`v2/indemnity?letterId=${id}`);
      }

      showMessage({
        type: 'success',
        title: 'Успешно',
        message: `${isReferral ? 'Напаравление' : 'Гарантийное письмо'} успешно удалено!`,
      });
    } catch (e) {
      console.warn(e);
      throw e;
    } finally {
      NProgress.done();
    }
  },
  async [localTypes.INDEMNITY_LETTER_ANNULMENT]({
    state: {
      annulmentReason,
    },
  }, {
    id, isReferral, executorName, executorPosition,
  }) {
    NProgress.start();

    try {
      const params = new URLSearchParams();
      params.append('id', id);
      params.append('reason', annulmentReason);
      params.append('executorName', executorName);
      params.append('executorPosition', executorPosition);

      let letter = null;

      if (isReferral) {
        const { data: { data } } = await api.get('v3/referral/annulment', { params });
        letter = data;
      } else {
        const { data } = await api.get('Indemnity/annulmentLetter', { params });
        letter = data;
      }

      return letter;
    } catch (e) {
      console.warn(e);
      throw e;
    } finally {
      NProgress.done();
    }
  },
  async [localTypes.NOSOLOGICAL_SERVICE_FETCH](_, params) {
    NProgress.start();

    try {
      const { data: { data } } = await api.post('v2/nosological-service/list', params);

      return data;
    } catch (e) {
      showMessage({ type: 'error', message: 'Не удалось получить нозологические сервисы' });
    } finally {
      NProgress.done();
    }
  },
  async [localTypes.PRICE_LIST_FETCH](_, params) {
    NProgress.start();

    try {
      const { data: { data } } = await api.post('v2/price/list-prices', params);

      return data;
    } catch (e) {
      showMessage({ type: 'error', message: 'Не удалось получить прайсы' });
    } finally {
      NProgress.done();
    }
  },
  async [localTypes.CLINIC_PRICE_LIST_FETCH](_, params) {
    NProgress.start();

    try {
      const { data: { data } } = await api.post('v2/price/list-clinic-prices', params);

      return data;
    } catch (e) {
      showMessage({ type: 'error', message: 'Не удалось получить прайсы' });
    } finally {
      NProgress.done();
    }
  },
  async [localTypes.PRICE_CLINICS_FETCH](_, params) {
    NProgress.start();

    try {
      const { data: { data } } = await api.post('v2/price/list-for-indemnity', params);

      return data;
    } catch (e) {
      showMessage({ type: 'error', message: 'Не удалось получить клиники' });
    } finally {
      NProgress.done();
    }
  },
  async [localTypes.PRICE_TEMPLATES_LIST_FETCH](_, params) {
    NProgress.start();

    try {
      const { data: { data } } = await api.post('v2/price-template/list', params);

      return data;
    } catch (e) {
      showMessage({ type: 'error', message: 'Не удалось получить шаблоны' });
    } finally {
      NProgress.done();
    }
  },
  async [localTypes.PRICE_TEMPLATE_CREATE](_, params) {
    NProgress.start();

    try {
      const { data: { data } } = await api.post('v2/price-template', params);

      showMessage({ type: 'success', message: 'Шаблон сохранен!' });
      return data;
    } catch (e) {
      showMessage({ type: 'error', message: 'Не удалось сохранить шаблон' });
    } finally {
      NProgress.done();
    }
  },
  async [localTypes.PRICE_TEMPLATE_UPDATE](_, params) {
    NProgress.start();

    try {
      const { data: { data } } = await api.put('v2/price-template', params);

      showMessage({ type: 'success', message: 'Шаблон сохранен!' });
      return data;
    } catch (e) {
      showMessage({ type: 'error', message: 'Не удалось сохранить шаблон' });
    } finally {
      NProgress.done();
    }
  },
  async [localTypes.PRICE_TEMPLATE_DELETE](_, { templateId }) {
    NProgress.start();

    try {
      const { data: { data } } = await api.delete(`v2/price-template?templateId=${templateId}`);

      showMessage({ type: 'success', message: 'Шаблон удален!' });
      return data;
    } catch (e) {
      showMessage({ type: 'error', message: 'Не удалось удалить шаблон' });
    } finally {
      NProgress.done();
    }
  },
  async [localTypes.PRICE_CLINIC_TEMPLATES_LIST_FETCH](_, params) {
    NProgress.start();

    try {
      const { data: { data } } = await api.post('v2/price-template/list-clinic-price', params);

      return data;
    } catch (e) {
      showMessage({ type: 'error', message: 'Не удалось получить шаблоны' });
    } finally {
      NProgress.done();
    }
  },
  async [localTypes.PRICE_CLINIC_TEMPLATE_CREATE](_, params) {
    NProgress.start();

    try {
      const { data: { data } } = await api.post('v2/price-template/clinic-price', params);

      showMessage({ type: 'success', message: 'Шаблон сохранен!' });
      return data;
    } catch (e) {
      showMessage({ type: 'error', message: 'Не удалось сохранить шаблон' });
    } finally {
      NProgress.done();
    }
  },
  async [localTypes.PRICE_CLINIC_TEMPLATE_UPDATE](_, params) {
    NProgress.start();

    try {
      const { data: { data } } = await api.put('v2/price-template/clinic-price', params);

      showMessage({ type: 'success', message: 'Шаблон сохранен!' });
      return data;
    } catch (e) {
      showMessage({ type: 'error', message: 'Не удалось сохранить шаблон' });
    } finally {
      NProgress.done();
    }
  },
  async [localTypes.PRICE_CLINIC_TEMPLATE_DELETE](_, { templateId }) {
    NProgress.start();

    try {
      const { data: { data } } = await api.delete(`v2/price-template/clinic-price?templateId=${templateId}`);

      showMessage({ type: 'success', message: 'Шаблон удален!' });
      return data;
    } catch (e) {
      showMessage({ type: 'error', message: 'Не удалось удалить шаблон' });
    } finally {
      NProgress.done();
    }
  },
};
